// Libraries
import sdpTransform from 'sdp-transform'

/**
 * Set all media to inactive in a given sdp string
 * @method setMediaInactive
 * @param  {string}  sdp An sdp string
 * @return {string}  Modified sdp string with media direction set to inactive
 */
export function setMediaInactive (sdp) {
  const regex = /sendrecv|sendonly|recvonly/gi
  if (!sdp || typeof sdp !== 'string') {
    return
  }

  return sdp.replace(regex, 'inactive')
}

/**
 * Helper function that returns a boolean if media is active or not.
 * @method hasMediaFlowing
 * @param  {string} sdp String representation of a calls sdp.
 */
export function * hasMediaFlowing (sdp) {
  const objectSdp = sdpTransform.parse(sdp)

  // Check that video directions (if there are any) indicate a "hold" scenario.
  const isVideoInactive = objectSdp.media
    .filter(item => item.type === 'video')
    .every(media => media && media.direction === 'inactive')

  // Check that audio directions (if there are any) indicate a "hold" scenario.
  const isAudioInactive = objectSdp.media
    .filter(item => item.type === 'audio')
    // Special case: In music on hold scenarios, audio may be `sendonly`
    //    so that the held user can still receive the "hold music".
    .every(media => media && ['inactive', 'sendonly'].includes(media.direction))

  return !isVideoInactive || !isAudioInactive
}

/**
 * Helper function that returns a boolean if media sendonly (music on hold).
 * @method hasMusicOnHold
 * @param  {string} sdp String representation of a calls sdp.
 */
export function * hasMusicOnHold (sdp) {
  const objectSdp = sdpTransform.parse(sdp)
  const isMusicOnHold = objectSdp.media
    .filter(item => item.type === 'audio')
    .some(media => media && media.direction === 'sendonly')

  // Check that video directions (if there are any) indicate a "hold" scenario.
  const isVideoInactive = objectSdp.media
    .filter(item => item.type === 'video')
    .every(media => media && media.direction === 'inactive')

  return isMusicOnHold && isVideoInactive
}
